<script lang="ts">
	import { page } from '$app/stores';
	import creditoConsolidado from '$lib/assets/images/insurance.webp';
	import novoCredito from '$lib/assets/images/simulation/simulacao_novo_credito.webp';
	import novoCreditoJovem from '$lib/assets/images/simulation/simulacao_novo_credito_jovem.webp';
	import novoCreditoPessoal from '$lib/assets/images/simulation/simulacao_novo_credito_pessoal.webp';
	import seguroVidaHab from '$lib/assets/images/simulation/simulacao_seguro_vida_habitacao.webp';
	import transferencia from '$lib/assets/images/simulation/simulacao_transferencia.webp';
	import simulationFrame from '$lib/assets/images/simulation/simulator_frame.webp';
	import __ from '$lib/stores/TranslationStore';
	import ContactSimulation from './ContactSimulation.svelte';
	import SimulationCard from './SimulationCard.svelte';
</script>

<div class="bg-white pt-14 md:pt-0" data-sveltekit-reload>
	<div class="container mx-auto px-5 py-4 text-dark md:pt-16 xl:px-24">
		<div>
			<div class="flex items-start justify-between lg:gap-x-28">
				<div class="flex flex-col gap-2 pb-5 lg:gap-5">
					<h2 class="text-xs font-semibold uppercase tracking-0.14 text-primary lg:text-sm">
						{$__('Simuladores')}
					</h2>
					<h1 class="text-3xl font-normal xl:text-5xl/54">
						{$__('Estes são os nossos simuladores')}
					</h1>
					<h3 class="text-lg leading-normal opacity-70 xl:text-2xl">
						{$__(
							'Pode usar e abusar, estão cá para o ajudar. Simule agora, avance hoje e poupe amanhã.'
						)}
					</h3>
				</div>
				<div class="hidden w-10/12 lg:block">
					<img class="w-full" src={simulationFrame} alt="Simulation Frame" />
				</div>
			</div>
			<div class="grid grid-cols-1 gap-5 md:py-16 lg:grid-cols-3">
				<SimulationCard title={$__('Simular novo crédito')} goto="/simulador/compra">
					<img
						slot="image"
						class="h-[inherit] w-[inherit] object-cover"
						src={novoCredito}
						alt={$__('Novo crédito')}
					/>
				</SimulationCard>
				<SimulationCard title={$__('Simular transferência')} goto="/simulador/transferencia">
					<img
						slot="image"
						class="h-[inherit] w-[inherit] object-cover object-top"
						src={transferencia}
						alt={$__('Transferência')}
					/>
				</SimulationCard>			
                <SimulationCard
                    title={$__('Simular crédito jovem 100% financiado')}
                    goto="/simulador/compra-jovem"
                >
                    <img
                        slot="image"
                        class="h-[inherit] w-[inherit] object-cover"
                        src={novoCreditoJovem}
                        alt={$__('Novo crédito')}
                    />
                </SimulationCard>
				{#if !$page.data.int_ch}
					<SimulationCard
						caption={$__('Crédito pessoal')}
						title={$__('Simular novo crédito')}
						goto="/simulador/novo-credito-pessoal"
					>
						<img
							slot="image"
							class="h-[inherit] w-[inherit] object-cover object-top"
							src={novoCreditoPessoal}
							alt={$__('Novo crédito pessoal')}
						/>
					</SimulationCard>
				{/if}
				<SimulationCard
					caption={$__('Crédito pessoal')}
					title={$__('Simular consolidado')}
					goto="/simulador/credito-consolidado"
				>
					<img
						slot="image"
						class="h-[inherit] w-[inherit] object-cover object-top"
						src={creditoConsolidado}
						alt={$__('Simular consolidado')}
					/>
				</SimulationCard>
				{#if !$page.data.int_ch}
					<SimulationCard
						caption={$__('Seguro')}
						title={$__('Simular seguro vida habitação')}
						goto="/simulador/seguro-vida-habitacao"
					>
						<img
							slot="image"
							class="h-[inherit] w-[inherit] object-cover object-top"
							src={seguroVidaHab}
							alt={$__('Simular seguro vida habitação')}
						/>
					</SimulationCard>
				{/if}
				<ContactSimulation />
			</div>
		</div>
	</div>
</div>
